import React, { useRef, useState, useEffect } from "react";
import LoginBannerhi from "../../assets/images/HindiBanner.gif";
import LoginBannermr from "../../assets/images/MarathiBanner.gif";
import LoginBannerka from "../../assets/images/KannadaBanner.png";
import LoginBannerte from "../../assets/images/TeluguBanner.gif";
import LoginBannerpb from "../../assets/images/PunjabiBanner.png";
import LoginBannergu from "../../assets/images/GujaratiBanner.jpg";
import LoginBannerta from "../../assets/images/tamilBanner.png";
import LoginBanneren from "../../assets/images/EnglishBanner.jpg";
import LoginBannerba from "../../assets/images/BanglaBanner.png";
import LoginBannerod from "../../assets/images/OdiyaBanner.png";
import ProductId from "../../assets/images/productId.png";
import Genuine_corteva_product from "../../assets/images/genuine_corteva_product.png";
import Not_Genuine from "../../assets/images/not_genuine.png";
import Packet from "../../assets/images/packet.jpg";
import LeftArrow from "../../assets/images/left.png";
import RightArrow from "../../assets/images/rightArrow.png";
import Header from "../../components/layout/Header";
import CustomModal from "../modal/index.js";
import { Button } from "react-bootstrap";
import { decryptJSON, fetchAPI } from "../service/Encrtyption.js";
import { useForm } from "react-hook-form";
import { json, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { cropValue, login, spinStatus } from "./redux/store.js";
import { Loader } from "../loader/index.js";
import { useParams } from "react-router-dom";
import ReactGA from 'react-ga4';
import OTPInput from "react-otp-input";
import { useSelector } from "react-redux";
import { genuityCheckData } from "./redux/store.js";
import {
  getScanLimitNotice,
  isScanLimitReached,
} from "../../utils/genuityCheck";
import { parseScanData } from "../../utils/parseScanData";
import { setOtpVerified } from "../../utils/otpSession";
import SpinImageHi from "../../assets/images/spinImage_hi.png";
import SpinImageMr from "../../assets/images/spinImage_mr.png";
import SpinImageKa from "../../assets/images/spinImage_ka.png";
import SpinImageTe from "../../assets/images/spinImage_te.png";
import SpinImagePb from "../../assets/images/spinImage_pb.png";
import SpinImageGj from "../../assets/images/spinImage_gj.png";
import SpinImageTa from "../../assets/images/spinImage_ta.png";
import SpinImageBn from "../../assets/images/spinImage_ba.png";
import SpinImageEn from "../../assets/images/spinImage_en.png";
import SpinImageOr from "../../assets/images/spinImage_or.png";
import SpinImageMa from "../../assets/images/spinImage_ma.png";
import CustomRoulette from "../WheelComponent/index.js";
import Close from "../../assets/images/close.png";
import SuccessIcon from "../../../src/assets/images/successIcon.png";
import PrivacyConsentContent from "../pages/privacyConsent/PrivacyConsentContent";
import { getPrivacyConsentNotice } from "../../content/privacyConsentNotice";
import Wrongotp from "../../assets/images/wrongotp.png";

import {
  OTP_VERIFY_INPUT_STYLES,
  OTP_INPUT_CONTAINER_STYLE,
  createOtpRenderInput,
} from "./otpVerifyInput.js";

const LOGIN_CUSTOM_MODAL_STYLES = `
.custom-modal__backdrop {
  background-color: rgba(0, 0, 0, 0.55) !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  height: 100% !important;
  transform: none !important;
}

.custom-modal__dialog {
  margin: 1rem auto !important;
}

.custom-modal__content {
  text-align: left !important;
  border: none !important;
  border-radius: 16px !important;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.22), 0 4px 16px rgba(0, 0, 0, 0.12) !important;
  padding: 0 !important;
  overflow: hidden;
  min-height: 300px;
}

.custom-modal .modal-lg .custom-modal__content {
  min-height: 420px;
}

.custom-modal__header {
  padding: 1rem 1.25rem !important;
  text-align: left !important;
  background-color: var(--secondary-color, #2bb24b) !important;
  border-radius: 16px 16px 0 0;
}

.custom-modal__title {
  font-size: 1.05rem !important;
  font-weight: 700 !important;
  text-align: left !important;
  color: #fff !important;
  line-height: 1.35;
}

.custom-modal__header .close,
.custom-modal__header .close img {
  filter: brightness(0) invert(1);
}

.custom-modal__body {
  text-align: left !important;
  padding: 0.85rem 1.35rem 1.35rem !important;
  min-height: 150px;
  font-size: 0.9rem;
  line-height: 1.55;
  color: #333;
}

.custom-modal__body p,
.custom-modal__body ul,
.custom-modal__body ol,
.custom-modal__body h6 {
  text-align: left !important;
}

.custom-modal__body .text-center {
  text-align: center !important;
}

.custom-modal__footer {
  justify-content: stretch !important;
  padding: 0 1.25rem 1.15rem !important;
  gap: 0.65rem;
}

.custom-modal__footer > * {
  width: 100%;
  margin: 0 !important;
}

.custom-modal .privacy-consent-content--modal {
  max-height: 58vh;
  min-height: 220px;
  overflow-y: auto;
  padding-right: 0.35rem;
}

.custom-modal .modalInfo {
  text-align: left !important;
}

.custom-modal .genuityCheckLimitMsg {
  text-align: left !important;
}

.consent-modal-footer-actions {
  display: flex;
  gap: 0.65rem;
  width: 100%;
}

.consent-modal-footer-actions .btn {
  flex: 1;
  margin: 0 !important;
  width: auto !important;
}

.consent-modal-footer-actions .consent-decline-btn {
  background-color: #fff !important;
  color: #2bb24b !important;
  border: 2px solid #2bb24b !important;
  font-weight: 600;
}

.consent-modal-footer-actions .consent-decline-btn:hover,
.consent-modal-footer-actions .consent-decline-btn:focus {
  background-color: #f5f5f5 !important;
  color: #0d5d29 !important;
  border-color: #0d5d29 !important;
}
`;

const Login = () => {
  const [selectedCrop, setSelectedCrop] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [GenunityCheckModal, setGenunityCheckModal] = useState(false);
  const [navbarWhite, setNavbarWhite] = useState(false);
  const [errroMsg, setErrorMsg] = useState("");
  const [disableBtn, setDisableBtn] = useState(false);
  const [otpDigits, setOtpDigits] = useState("");
  const [resend, setResend] = useState("");
  const [loading, setLoading] = useState(false);
  const [oTPSec, setOTPSec] = useState(false);
  const [otpValid, setOtpValid] = useState(false);
  const [scanResponseData, setScanResponseData] = useState({});
  const [ErrorModalGenunity, setErrorModalGenunity] = useState(false);
  const [scanErrorResponseData, setscanErrorResponseData] = useState({});
  const [spinModalShow, setSpinModalShow] = useState(false);
  const [stopPrizeNumber, setStopPrizeNumber] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [apiProductName, setApiProductName] = useState("");
  const [productID, setProductID] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [scanedDataObject, setScanedDataObject] = useState(false);
  const [rewardUpdateModal, setRewardUpdateModal] = useState(false);
  const [consentModalShow, setConsentModalShow] = useState(false);
  const [consentAccepted, setConsentAccepted] = useState(false);
  const [pendingSubmitAfterConsent, setPendingSubmitAfterConsent] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [surl, setsurl] = useState('');
  const [name, setName] = useState('');
  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const currentLanguage = lang;
  const [secondaryRewardMsg, setSecondaryRewardMsg] = useState("");
  const [stepOneClear, setStepOneClear] = useState(false);
  const [stepTwoClear, setStepTwoClear] = useState(false);


  //console.log("currentLanguage+"+currentLanguage);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //login object to send for server
  const productName = sessionStorage.getItem('storedProductName');
  const [loginSubmit, setLoginSubmit] = useState({
    deviceType: "WEB",
    mobileNumber: "",
    otp: "",
    destinationURL: "/customer/saveGenuinityCheckDetails_V3_acviss",
    deviceId: "",
    otpVerified: false,
    countryId: 5,
    appLangCode: currentLanguage,
    directScanConsentAgreed: true
  });

  ///dat form the store
  const user = useSelector((state) => state?.user);
  const scanedData = useSelector((state) => state?.scandataUrl);
  const genunityData = useSelector((state) => state?.genunityData);
  const giftImageUrl = useSelector((state) => state?.giftImageUrl);
  const [timer, setTimer] = useState(35);
  const [showTimer, setShowTimer] = useState(true);
  const [cropList, setCropList] = useState([]);
  const [wheelItems, setWheelTems] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
  } = useForm();


  const [formData, setFormData] = useState({
    mobileNumber: "",
    deviceId: "",
    programName: "gallant",
    userAcceptanceKey: "0",
    destinationURL: "/customer/sendOTPForMicrosite",
  });

  ///  enble for submit btn 

  //validations

  const handleCropChange = (event) => {
    // debugger;
    const value = event.target.id
    setSelectedCrop(value);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      cropName: false,
    }));
    dispatch(cropValue(value));
  };

  const handleInputNameChange = (e) => {
    const { name, value } = e.target;

    if (name === "name") {
      // Allow all languages + combining marks + spaces
      const nameValue = value.replace(/[^\p{L}\p{M}\s]/gu, "");

      const validValue = nameValue.slice(0, 50);

      e.target.value = validValue;

      if (validValue.length >= 3) {
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          name: false,
        }));
      }

      setName(validValue);
    }

    clearErrors(name);
  };

  // const handleInputNameChange = (e) => {
  //   // debugger;
  //   const { name, value } = e.target;
  //   let validValue = value;
  //   if (name === "name") {
  //     const inputValue = value;
  //     const namevalue = inputValue.replace(/[^a-zA-Z ]/g, "");
  //     const alphabeticValue = namevalue.slice(0, 50);
  //     e.target.value = alphabeticValue;
  //     if (alphabeticValue.length >= 3) {
  //       setFormErrors((prevErrors) => ({
  //         ...prevErrors,
  //         name: false,
  //       }));
  //     }
  //     setName(alphabeticValue);
  //   }
  //   clearErrors(name);
  // };


  const handleMobileInputChange = (e) => {
    // debugger;
    const { name, value } = e.target;
    let validValue = value;
    if (name === "mobileNumber") {
      const inputValue = value;
      const numericValue = inputValue.replace(/\D/g, ""); // Remove non-numeric characters
      const limitedValue = numericValue.slice(0, 10); // Limit input to 10 characters
      const validValue = /^[6-9]\d{0,9}$/.test(limitedValue) ? limitedValue : ""; // Ensure the first digit is 6, 7, 8, or 9 and limit to 10 digits
      e.target.value = validValue; // Update the input value  
      if (validValue.length >= 10) {
        setMobileNumber(validValue);
        setFormErrors((prevErrors) => ({
          ...prevErrors,
          mobileNumber: false,
        }));
        setFormData((prevFormData) => {
          const newFormData = {
            ...prevFormData,
            [name]: validValue,
          };
          return newFormData;
        });
      } else {
        setMobileNumber('');
        setOTPSec(false);
      }
    }

    clearErrors(name);
  };

  useEffect(() => {
    if (selectedCrop && name && mobileNumber) {
      setDisableBtn(true);
    } else {
      setDisableBtn(false);
    }
  }, [selectedCrop, name, mobileNumber]);


  const handleConsentCheckboxChange = () => {
    if (consentAccepted) {
      setConsentAccepted(false);
      return;
    }
    setPendingSubmitAfterConsent(false);
    setConsentModalShow(true);
  };

  const closeConsentModal = () => {
    setConsentModalShow(false);
    setPendingSubmitAfterConsent(false);
  };

  const handleConsentAccept = async () => {

    ReactGA.event({
      category: 'Btn',
      action: 'Consent Accept Clicked',
      label: 'User Consent'
    });

    setConsentAccepted(true);
    setConsentModalShow(false);
    const shouldSubmit = pendingSubmitAfterConsent;
    setPendingSubmitAfterConsent(false);
    if (shouldSubmit) {
      await proceedWithLoginSubmit();
    }
  };

  const handleConsentDecline = () => {
    ReactGA.event({
      category: "Btn", 
      label: "User Consent",
      action: "Consent Declined Clicked",
    });
    setConsentAccepted(false);
    closeConsentModal();
  };

  const openConsentModal = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    ReactGA.event({
      category: 'Btn', 
      label: 'Know More',
      action: 'Know More Clicked'
    });
    setPendingSubmitAfterConsent(false);
    setConsentModalShow(true);
  };

  const isLoginFormValid =
    name?.trim().length >= 3 && mobileNumber?.length === 10;

  const proceedWithLoginSubmit = async () => {
    const scanedData = sessionStorage.getItem("k");

    if (!scanedData) {
      setErrorMsg("Please Scan the QR Code");
      return;
    }

    ReactGA.event({
      category: "Btn",
      action: "Send OTP Clicked",
      label: "Send OTP Button"
    });

    setLoading(true);

    try {
      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL,
        formData,
        {
          appLangCode: currentLanguage,
        }
      );

      console.log("Submitted form data: " + JSON.stringify(formData));

      const jsonReposneData = JSON.parse(responseData);

      console.log("Response from API: " + JSON.stringify(jsonReposneData));
      setOtpVerified(false);
      dispatch(login(jsonReposneData));
      if (jsonReposneData.statusCode === "200") {
        sessionStorage.setItem("name", name);
        sessionStorage.setItem("mbn", jsonReposneData.mobileNumber);
        sessionStorage.setItem("cid", jsonReposneData.customerId);
        navigate(`/${i18n.language}/verifyOtp`);
      } else if (jsonReposneData.statusCode === "103") {
        handleLoginModal();
      } else if (jsonReposneData.statusCode === "101") {
        const decryptedData = decryptJSON(scanedData).replace(/"/g, "");
        registerNewUser(decryptedData);
      } else {
        setErrorMessage(jsonReposneData.message);
        navigate(`/${i18n.language}/verifyOtp`);
      }
    } catch (error) {
      console.error("Error fetching API:", error);
    } finally {
      setLoading(false);
    }
  };

  ////OTP submit and form submit for login

  const onSubmit = async (e) => {
    let errors = {};
    if (!name || name.trim() === "") {
      errors = { ...errors, name: true };
    } else {
      errors = { ...errors, name: false };
    }

    if (!mobileNumber) {
      errors = { ...errors, mobileNumber: true };
    } else {
      errors = { ...errors, mobileNumber: false };
    }

    setFormErrors(errors);

    if (errors.name || errors.mobileNumber) {
      return;
    }

    if (!consentAccepted) {
      setPendingSubmitAfterConsent(true);
      setConsentModalShow(true);
      return;
    }

    await proceedWithLoginSubmit();
  };


  //resend verfiy otp for forcecheckout

  const handleLoginModal = async () => {
    // debugger;
    setLoading(true);
    try {
      // Update user acceptance key to '1' and update the formData state
      const updatedFormData = {
        ...formData,
        userAcceptanceKey: "1",
      };
      setFormData(updatedFormData);

      // Resubmit the form with updated data
      const updatedResponseData = await fetchAPI(
        process.env.REACT_APP_API_URL,
        updatedFormData
      );
      const updatedJsonResponseData = JSON.parse(updatedResponseData);
      if (updatedJsonResponseData.statusCode === "200") {
        setOtpVerified(false);
        dispatch(login(updatedJsonResponseData));
        const scanedData = sessionStorage.getItem('k');
        const surlderypted = decryptJSON(scanedData).replace(/"/g, '');
        // setOTPSec(true); 
        navigate(`/${i18n.language}/verifyOtp`);
      } else {
        // navigate(`/${i18n.language}/login`);
        navigate(`/${i18n.language}/verifyOtp`);
      }
    } catch (error) {
      console.error("Error fetching API:", error);
    } finally {
      setLoading(false); // Set loading state to false after API call is completed
    }
  };

  ///validations

  const handleOTPInputChange = (otpDigits) => {
    setLoginSubmit((prevFormData) => ({
      ...prevFormData,
      ...scanedDataObject,
      otp: otpDigits,
      mobileNumber: mobileNumber,
      customerId: user?.customerId,
      moduleType: productName
    }));

    setOtpDigits(otpDigits);
  };

  function OTPValidate(event) {
    const pattern = /[0-9]/; // Allow only digits (0-9)
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  const handleOtpFormSubmit = (e) => {
    e.preventDefault();
    onLogin();
  };
  //end otp code

  useEffect(() => {
    const queryString = window?.location?.href?.split("?")[1];
    const queryParams = {};
    queryString?.split("&")?.forEach((pair) => {
      const [key, value] = pair?.split("=");
      queryParams[key] = value;
    });
    const uParamValue = queryParams["u"];
    setsurl(uParamValue);
    // console.log(surl +"niha"); 
  }, []);

  ///login code for submititing the details
  const onLogin = async () => {
    // debugger;
    setLoading(true);
    ReactGA.event({
      category: 'Btn',
      label: 'OTP Submitted',
      action: 'Verify OTP Clicked'
    });

    try {
      const { otp } = loginSubmit; // Assuming 'otp' is the key for the OTP value
      const trimmedOtp = otp.trim();
      if (!otp || otp.trim() === "" || trimmedOtp.length !== 4) {
        // Check if OTP is empty or only whitespace
        setErrorMsg(t("otpError")); // Set an error message for empty OTP
        setLoading(false);
        return;
      }

      if (!surl) {
        // setErrorMsg("Please scan the QR code to proceed");
        setErrorMsg(t("sessionExperied"));
        setLoading(false);
        return;
      }

      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL_SCAN,
        loginSubmit,
        {
          mobileNumber: user?.mobileNumber,
          customerId: user?.customerId,
          userAuthorizationToken: "",
          deviceid: "WEB",
          appLangCode: currentLanguage
        }
      );
      // debugger;
      console.log(JSON.stringify(loginSubmit) + "otp submit data");
      //  alert(JSON.stringify(loginSubmit));
      const jsonReposneData = JSON.parse(responseData);
      console.log(jsonReposneData, "otp response data");
      if (
        jsonReposneData?.statusCode === "200" && jsonReposneData?.uq_responseCode === "100") {
        console.log("jsonReposneData" + JSON.stringify(jsonReposneData));
        // console.log(JSON.stringify(jsonReposneData.strongArmObject)+"strongArmObject"); 
        // const strongArmObject = jsonReposneData.strongArmObject;
        let resProductID = null;
        if (jsonReposneData.strongArmObject?.textTwo) {
          resProductID = jsonReposneData.strongArmObject.textTwo;
        }

        // const resProductID = jsonReposneData.prodSerialNumber;
        // const resProductID = strongArmObject.textTwo;
        const resProductName = jsonReposneData.productName;
        const resProfileUpdate = jsonReposneData.profileUpdate;
        const resShareProductInfo = jsonReposneData.shareProductInfo;
        // alert(resProfileUpdate + "profileUpdate" + resShareProductInfo + "resShareProductInfo");
        setProductID(resProductID);
        setApiProductName(resProductName);
        setStepOneClear(resProfileUpdate);
        setStepTwoClear(resShareProductInfo);
        const apiSecondaryRewardMsg = jsonReposneData.secondaryRewardMsg;
        setSecondaryRewardMsg(apiSecondaryRewardMsg);
        setScanResponseData(jsonReposneData);
        dispatch(genuityCheckData(jsonReposneData));
        // setGenunityCheckModal(true);

        if (jsonReposneData.isAlreadyScannedProduct === true) {
          navigate(`/${currentLanguage}/giftClaim`);
          // setErrorModalGenunity(true);
          return;
        }

        if (!jsonReposneData.soyabeanAcres || jsonReposneData.soyabeanAcres == 0 || jsonReposneData.soyabeanAcres === null || jsonReposneData.soyabeanAcres === undefined) {
          navigate(`/${currentLanguage}/register`);
        }

        else {
          setGenunityCheckModal(true);
          setNavbarWhite(true);
          setOtpValid(true);
          setShowTimer(false);
        }

        setNavbarWhite(true);
        setOtpValid(true);
        setOtpVerified(true);
        setShowTimer(false);
      } else if (jsonReposneData?.statusCode === "200" && jsonReposneData?.uq_responseCode != "100") {
        //debugger;
        setLoading(false);
        setScanResponseData(jsonReposneData);
        setErrorModalGenunity(true);
        setNavbarWhite(true);
      } else {
        if (jsonReposneData?.statusCode === "123") {
          setDisableBtn(true);
          setErrorMsg(jsonReposneData?.message || t("invalid_OTP"));
          setOtpDigits("");
          setOtpValid(false);
          setOtpVerified(false);
          setShowTimer(false);
          setResend(true);
        } else {
          setOtpValid(false);
          setOtpVerified(false);
          setErrorMsg(jsonReposneData?.message || t("invalid_OTP"));
        }
      }
    } catch (error) {
      //  debugger;
      setErrorMsg("Please scan the QR code to proceed");
      console.error("Error fetching API:", error);
    } finally {
      setLoading(false);
    }
  };

  //end login code

  const renderInput = createOtpRenderInput({
    getCurrentOtp: () => loginSubmit.otp || otpDigits,
    onEnter: onLogin,
    onKeyPressValidate: OTPValidate,
  });

  const hide = () => {
    setErrorMsg(""); // Assuming you have a state to manage the error message
  };

  const scanLimitReached = isScanLimitReached(scanResponseData);
  const scanLimitNotice =
    getScanLimitNotice(scanResponseData) || scanResponseData.uq_message || t("genuityCheck.scanLimitFallback");

  const handleGenuityScanMore = () => {
    ReactGA.event({
      category: "Btn",
      label: "User Scan More",
      action: "Clicked the Scan More Button",
    });
    setGenunityCheckModal(false);
    navigate(`/${lang}/scanProduct`);
  };

  const handleGenuityProceedCashback = () => {
    if (scanLimitReached) return;
    ReactGA.event({
      category: "Btn",
      label: "User Proceed to Cashback",
      action: "Clicked the Proceed to Cashback Button",
    });
    setGenunityCheckModal(false);
    navigate(`/${lang}/rewardjourney`);
  };

  //change baneer based on the lang

  let bannerImageSrc;
  if (lang === 'hi') {
    bannerImageSrc = LoginBannerhi;
  } else if (lang === 'mr') {
    bannerImageSrc = LoginBannermr;
  } else if (lang === 'kn') {
    bannerImageSrc = LoginBannerka;
  } else if (lang === 'te') {
    bannerImageSrc = LoginBannerte;
  } else if (lang === 'pa') {
    bannerImageSrc = LoginBannerpb;
  } else if (lang === 'gu') {
    bannerImageSrc = LoginBannergu;
  } else if (lang === 'ta') {
    bannerImageSrc = LoginBannerta;
  } else if (lang === 'en') {
    bannerImageSrc = LoginBannerhi;
  } else if (lang === 'or') {
    bannerImageSrc = LoginBannerod;
  } else if (lang === 'bn') {
    bannerImageSrc = LoginBannerba;
  } else if (lang === 'ma') {
    bannerImageSrc = LoginBanneren;
  }
  else {
    bannerImageSrc = LoginBannerhi;
  }

  //change logo based on the lang

  let bannerLogoSrc;
  if (lang === 'hi') {
    bannerLogoSrc = SpinImageHi;
  } else if (lang === 'mr') {
    bannerLogoSrc = SpinImageMr;
  } else if (lang === 'kn') {
    bannerLogoSrc = SpinImageKa;
  } else if (lang === 'te') {
    bannerLogoSrc = SpinImageTe;
  } else if (lang === 'pa') {
    bannerLogoSrc = SpinImagePb;
  } else if (lang === 'gu') {
    bannerLogoSrc = SpinImageGj;
  } else if (lang === 'ta') {
    bannerLogoSrc = SpinImageTa;
  } else if (lang === 'bn') {
    bannerLogoSrc = SpinImageBn;
  } else if (lang === 'en') {
    bannerLogoSrc = SpinImageEn;
  } else if (lang === 'or') {
    bannerLogoSrc = SpinImageHi;
  } else if (lang === 'ma') {
    bannerLogoSrc = SpinImageHi;
  }
  else {
    bannerLogoSrc = SpinImageHi;
  }

  const handleSpin = () => {
    dispatch(spinStatus(true));
  };

  const handleScanMore = () => {
    // dispatch(spinStatus(true));
  };



  // for close popups'
  const handleCloseModal = () => {
    setSpinModalShow(false);
    setRewardUpdateModal(true);
  };

  useEffect(() => {
    const result = parseScanData(scanedData);
    if (result) {
      setScanedDataObject(result);
    }
  }, [scanedData]);


  const handleNavigation = () => {
    //debugger;
    if (user) {
      navigate(`/${lang}/giftHistory`);
    } else {
      const currentPath = `/login`;
      navigate(`/${lang}${currentPath}}`);
    }
  };

  const [formErrors, setFormErrors] = useState({
    name: false,
    mobileNumber: false,
    cropName: false
  });

  //register
  const registerNewUser = async () => {

    ReactGA.event({
      category: 'Btn', 
      label: 'User Registered',
      action: 'Register Btn Clicked'
    });


    //debugger;
    const obj = {
      cepFlag: false,
      countryId: 5,
      customerType: "Farmer",
      deviceId: "",
      deviceToken: "",
      firstName: name,
      geolocation: "",
      languageId: "1",
      lastName: name,
      mobileNumber: mobileNumber,
      optInWhatsApp: false,
      pincode: scanedDataObject.pincode,
      referrer: "",
      rhrdFlag: false,
      villageLocation: "",
      wheatProgramFlag: false,
      destinationURL: "/customer/registerCustomerForMicrosite",
    }

    try {
      const responseData = await fetchAPI(
        process.env.REACT_APP_API_URL,
        obj,
        {
          authKey: "",
          methodName: "",
          sharedWith: "",
        }
      );
      console.log("jsonReposneDataOBJ" + JSON.stringify(formData));
      const jsonReposneData = JSON.parse(responseData);
      console.log("jsonReposneData" + JSON.stringify(jsonReposneData));
      if (jsonReposneData.statusCode == 200 && jsonReposneData.otp) {
        sessionStorage.setItem('name', name);
        sessionStorage.setItem('mbn', jsonReposneData.mobileNumber);
        sessionStorage.setItem('cid', jsonReposneData.customerId);
        dispatch(login(jsonReposneData));
        // setOTPSec(true);
        navigate(`/${i18n.language}/verifyOtp`);
      } else {
        setErrorMessage(jsonReposneData.message);
        setOTPSec(false);
      }
    } catch (error) {
      console.error("Error fetching API:", error);
      setErrorMessage(error);
    } finally {
      setLoading(false);
    }
  };

  ///for pop up 
  const openSpinWheel = () => {
    if (stepOneClear && stepTwoClear) {
      navigate(`/${currentLanguage}/rewardjourney?m=${encodeURIComponent(btoa(mobileNumber))}`);
    } else {
      navigate(`/${currentLanguage}/congratulations?m=${encodeURIComponent(btoa(mobileNumber))}&profileUpdate=${stepOneClear}&shareProductInfo=${stepTwoClear}`);
    }
  };

  useEffect(() => {
    if (!showTimer) return;

    const countdown = setInterval(() => {
      if (otpValid) {
        clearInterval(countdown);
        setShowTimer(false);
        // setResend(true);
        console.log('Timer stopped due to otpValid = true');
        return;
      }

      setTimer((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(countdown);
          setShowTimer(false);
          setResend(true);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(countdown);
  }, [otpValid, showTimer]);

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min < 10 ? '0' + min : min}:${sec < 10 ? '0' + sec : sec}`;
  };

  return (
    <>
      <style>{`${LOGIN_CUSTOM_MODAL_STYLES}\n${OTP_VERIFY_INPUT_STYLES}`}</style>
      <Header navbarWhite={navbarWhite} hideHomeIcon={!otpValid} />
      <div className="main px-2 mt-3">
        <div className="container p-0">
          {loading && <Loader />}
          <b>
            <p
              style={{
                fontWeight: "600",
                color: "#000000",
                textAlign: "center",
              }}
            >
              {t("fillYourInformationHeading")}
            </p>
          </b>
          <div className="card px-0 border-0">
            <img
              src={bannerImageSrc}
              className="img-fluid w-100 shadow"
              alt="banner"
            />
            <div className="card-body px-0 pb-2 pt-0 pb-2">
              <div>

                {/* <div style={{ backgroundColor: '#F5F5F5', height: '6px' }}></div> */}
                {/* <h4 className="text-center" id="headingText">{t('Strongarm_Survey')}</h4> */}

                <form onSubmit={handleSubmit(onSubmit)} className="px-3 pt-3">
                  {/* <h6 className="detailsHeading">{t('Enter_Details')}</h6> */}

                  {/* <div className="form-group mt-3 mb-4" >
                    <div className=" d-flex justify-content-between align-items-center cropSec">
                      {cropList?.map((item, index) => (
                        <div className="form-check form-check-inline">
                          <input className="form-check-input" type="radio"
                            name="cropName" id={item.name} onChange={handleCropChange} />
                          <img src={item.imageUrl} alt="Close" className="cropImg" />
                          <label className="form-check-label cropName" htmlFor={item.name}>
                            {item.name}
                          </label>
                        </div>
                      ))}
                    </div>
                    {formErrors.cropName && <div className="text-danger">{t("cropErrorMsg")}</div>} 
                  </div> */}


                  {/* <div className="form-group mt-3">
                    <div className=" d-flex justify-content-between align-items-center"> */}
                  {/* <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="cropName" id="cotton" onChange={handleCropChange} />
                        <img src={CottonImage} alt="Close" className="cropImg" />
                        <label className="form-check-label cropName" htmlFor="cotton">
                          {t("cottn")}
                        </label>
                      </div> */}

                  {/* <div className="form-check form-check-inline">
                        <input className="form-check-input" type="radio" name="cropName" id="corn" onChange={handleCropChange} />
                        <img src={CornImage} alt="Close" className="cropImg" />
                        <label className="form-check-label cropName" htmlFor="corn">
                          {t("corn")}
                        </label>
                      </div> */}
                  {/* </div>
                    {formErrors.cropName && <div className="text-danger">{t("cropErrorMsg")}</div>}
                  </div> */}

                  {/* <label htmlFor="name">{t("name")}</label> */}
                  <div className="form-group">
                    {/* <label htmlFor="name" className="labelText">{t('Name')}<span className="required">*</span></label> */}
                    <input type="text" className={`form-control  mb-1 ${errors.name ? "is-invalid" : ""
                      }`}
                      placeholder={t("name")}
                      name="name"
                      id="name"
                      autoComplete="off"
                      onChange={handleInputNameChange}
                    />
                    {formErrors.name && <div className="text-danger">{t("nameErrorMsg")}</div>}
                  </div>

                  {/* <label htmlFor="mobileNumber"> {t("loginLabel")}</label> */}
                  <div className="form-group">
                    {/* <label htmlFor="name" className="labelText">{t('loginLabel')}<span className="required">*</span></label> */}
                    <input
                      type="tel"
                      className={`form-control  mb-1 ${errors.mobileNumber ? "is-invalid" : ""
                        }`}
                      placeholder={t("loginPlaceHolder")}
                      name="mobileNumber"
                      id="mobileNumber"
                      maxLength="10"
                      autoComplete="off"
                      onChange={handleMobileInputChange} />
                    {formErrors.mobileNumber && <div className="text-danger">{t("mobileErrorMsg")}</div>}
                  </div>

                  {oTPSec && (
                    <form id="otp-verify-form" onSubmit={handleOtpFormSubmit}>
                      <div className="form-group mt-3" id="opt_input">
                        <div
                          className="mb-3"
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}
                        >
                          <label htmlFor="number" className="mt-0" style={{ fontWeight: '600' }}>
                            {t("enterOTP")}
                          </label>

                          {showTimer && (<div
                            id="timer"
                            style={{
                              color: 'white',
                              fontWeight: 600,
                              fontSize: '12px',
                              backgroundColor: 'red',
                              padding: '5px 15px',
                              borderRadius: '25px',
                              width: 'fit-content',
                              height: 'fit-content',
                            }}>
                            {formatTime(timer)}
                          </div>
                          )}

                        </div>

                        <OTPInput
                          onChange={handleOTPInputChange}
                          value={otpDigits}
                          numInputs={4}
                          containerStyle={OTP_INPUT_CONTAINER_STYLE}
                          renderInput={renderInput}
                        />
                      </div>
                    </form>
                  )}

                  {/* {oTPSec && (
                    <div className="" id="privacyPolicyview">
                      <p className="privacyPolicyviewText">
                        {(() => {
                          const content = {
                            en: {
                              textBefore: [
                                "By clicking the submit button, You acknowledge reading",
                                "and accepting our"
                              ],
                              termsText: "Terms & Conditions",
                              andText: " and ",
                              privacyText: "Privacy Policy",
                              textAfter: ""
                            },
                            te: {
                              textBefore: [
                                "'సబ్మిట్' బటన్‌ను క్లిక్ చేయడం ద్వారా, మీరు",
                                " "
                              ],
                              termsText: "మా నిబంధనలు & షరతులు",
                              andText: " మరియు ",
                              privacyText: "గోప్యతా విధానాన్ని",
                              textAfter: " చదివి అంగీకరించారని నిర్ధారిస్తారు."
                            },
                            hi: {
                              textBefore:
                                "‘आगे बढ़ें’ बटन पर क्लिक करके, आप हमारी",
                              termsText: "नियम और शर्तें",
                              andText: [" तथा ",
                                " "
                              ],
                              privacyText: "गोपनीयता नीति",
                              textAfter: " पढ़ने और स्वीकार करने की पुष्टि करते हैं।"
                            },
                            mr: {
                              textBefore: "सबमिट बटण क्लिक करून, आपण",
                              termsText: "आमच्या अटी व शर्ती",
                              andText: ["आणि", " "],
                              privacyText: "गोपनीयता धोरण",
                              textAfter: "वाचले असून त्यांना स्वीकारत असल्याची खात्री देता."
                            }
                          };

                          const {
                            textBefore,
                            termsText,
                            andText,
                            privacyText,
                            textAfter
                          } = content[lang] || content.en;

                          return (
                            <>
                              {Array.isArray(textBefore) ? (
                                <>
                                  {textBefore[0]}<br />
                                  {textBefore[1]}{" "}
                                </>
                              ) : (
                                textBefore
                              )}
                              <a
                                style={{ color: '#DB710E' }}
                                target="_blank"
                                href={`${process.env.REACT_APP_API_URL_TC}${t("language")}`}
                                rel="noopener noreferrer"
                              >
                                <span className="text-decoration-underline">{termsText}</span>
                              </a>
                              {andText}
                              <a
                                style={{ color: '#DB710E' }}
                                target="_blank"
                                href="https://www.corteva.com/privacy.html"
                                rel="noopener noreferrer"
                              >
                                <span className="text-decoration-underline">{privacyText}</span>
                              </a>
                              {textAfter}
                            </>
                          );
                        })()}
                      </p>
                    </div>
                  )} */}

                  <div className="consent-check-row">
                    <input
                      type="checkbox"
                      className="consent-checkbox"
                      id="consentCheckbox"
                      checked={consentAccepted}
                      onChange={handleConsentCheckboxChange}
                      aria-label={t("cortevaInfo")}
                    />
                    <label className="consent-check-label" htmlFor="consentCheckbox">
                      <span className="consent-check-text">{t("cortevaInfo")}</span>{" "}
                      <button
                        type="button"
                        className="consent-know-more-btn"
                        onClick={openConsentModal}
                      >
                        {t("knowmore")}
                      </button>
                    </label>
                  </div>

                  {!oTPSec && (
                    <button
                      type="submit"
                      className="btn submitBtn text-center btn-secondary py-2 center-textbtn mt-3 text-white btnshadow"
                      id="submitBtn"
                      disabled={!isLoginFormValid || loading}
                    >
                      {t("submitBtn")}
                    </button>
                  )}

                  {/* {resend && (
                    <div className="text-center mb-2 resend d-flex align-items-center justify-content-center">
                      <div id="resend_text" className="text-center">{t('invalid_OTP')}? </div>
                      <button
                        type="submit"
                        className={`btn text-center text-secondaryColor p-0 `}>
                        <b className="ml-1">{t('resend_OTP')}</b>
                      </button>
                    </div>
                  )} */}

                </form>

                {oTPSec && (
                  <button
                    type="submit"
                    form="otp-verify-form"
                    className="btn submitBtn text-center btn-secondary w-100 py-2 center-textbtn mt-3 my-2 text-white btnshadow"
                    id="submitBtn"
                    disabled={otpDigits.length !== 4 || loading}
                  >
                    {t("selectPayment.proceedButton")}
                  </button>
                )}

                {errroMsg && (
                  <>
                    <div
                      className="alert alert-warning alert-dismissible fade show mt-2"
                      role="alert"
                    >
                      {errroMsg}
                      <button
                        type="button"
                        className="close"
                        onClick={hide}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </>
                )}

                {/* {!oTPSec && (<div className="text-center my-4" style={{ fontSize: "15px" }}>
                  {lang === 'en' && (<span>{t("visit")}</span>)} {" "}
                  <a className="text-black"
                    href={`${process.env.REACT_APP_API_URL_TC}${t("language")}`}>
                    <span className="text-decoration-underline text-primary">{t("termsAndConditions")}</span></a> {" "}
                  {lang !== 'en' && (<span>{t("visit")}</span>)}
                </div>)} */}


                <CustomModal
                  id="consentDetailsModal"
                  size="lg"
                  title={getPrivacyConsentNotice(lang).title}
                  content={<PrivacyConsentContent lang={lang} modal />}
                  footer={
                    <div className="consent-modal-footer-actions w-100">
                      <Button
                        type="button"
                        className="rounded-4 py-2 consent-decline-btn btnshadow"
                        onClick={handleConsentDecline}
                      >
                        {t("consentDecline")}
                      </Button>
                      <Button
                        type="button"
                        className="rounded-4 py-2 btn-secondary btnshadow"
                        onClick={handleConsentAccept}
                      >
                        {t("consentAgree")}
                      </Button>
                    </div>
                  }
                  show={consentModalShow}
                  onHide={closeConsentModal}
                />

                {/* //genuinityCheckModal */}
                <CustomModal
                  id={"genuinityCheckModal"}
                  title={
                    <>
                      {/* {!scanedDataObject.hasOwnProperty('isSpinDone') && (
                        <button
                          type="button"
                          className="close"
                          aria-label="Close"
                          onClick={handleNavigation}
                        >
                          <img src={Close} alt="Close" />
                        </button>
                      )} */}

                      {t("genuityCheck")}
                    </>
                  }
                  content={
                    <>
                      {/* {scanResponseData?.productName} */}
                      {/* <p className="mb-1 modalInfo" style={{ textTransform: 'capitalize' }}>
                        {t("productName")}: {apiProductName}
                      </p> */}
                      {/* <img src={scanResponseData.productImageUrl} alt="GenuityCheck" style={{ width: '100px', marginBottom: '1rem' }} /> */}

                      <div style={{ position: 'relative' }}>
                        <img src={Packet} alt="GenuityCheck" style={{ width: '200px' }} />
                        <img src={Genuine_corteva_product} alt="Genuine_corteva_product" className="Genuine_corteva_product" />
                      </div>

                      {productID && (<div className="text-left mb-2" style={{ marginTop: "3rem" }}>
                        <p className="mb-1">{t('Product_Serial_Number')}</p>
                        <p className="mb-0" style={{ display: 'block', fontWeight: '600' }}>
                          <img src={ProductId} alt="ProductId" className='img-fluid mr-2' style={{ width: '35px' }} />
                          {productID}</p>
                      </div>
                      )}

                      {scanLimitReached && (
                        <p
                          className="genuityCheckLimitMsg text-center mb-2 px-2"
                          dangerouslySetInnerHTML={{
                            __html: scanLimitNotice.replace(/\r\n|\n|\r/g, "<br />"),
                          }}
                        />
                      )}

                      {scanResponseData.isAlreadyScannedProduct && (
                        <>
                          <p className={`${!productID ? 'mt-10' : ''} mb-2 modalInfo text-danger pt-2`} dangerouslySetInnerHTML={{ __html: scanResponseData?.primaryRewardMsg }}>
                          </p>
                        </>
                      )}
                    </>
                  }
                  footer={
                    <div className="genuityCheckModalFooter w-100">
                      <Button
                        className="w-100 rounded-4 py-2 btn-secondary btnshadow"
                        onClick={handleGenuityScanMore}
                      >
                        {t("Scanmore")}
                      </Button>
                      {!scanLimitReached && (
                        <Button
                          className="w-100 rounded-4 py-2 btn-secondary btnshadow"
                          onClick={handleGenuityProceedCashback}
                        >
                          {t("genuityCheck.proceedToCashback")}
                        </Button>
                      )}
                    </div>
                  }
                  show={GenunityCheckModal}
                  onHide={() => setGenunityCheckModal(false)}
                />

                {/*///not genuine case */}

                <CustomModal
                  id={"genuinityCheckModalError"}
                  title={
                    <>
                      {/* <button
                        type="button"
                        className="close"
                        aria-label="Close"
                        onClick={() => {
                          setErrorModalGenunity(false);
                          handleNavigation();
                        }}
                      >
                        <img src={Close} alt="Close" />
                      </button> */}

                      {/* {t("genuityCheck")} */}

                    </>
                  }

                  content={
                    <>

                      {/* <p className="mb-1 modalInfo">{t("serialNO")}: {scanResponseData.prodSerialNumber}</p> */}
                      {/* {scanErrorResponseData?.productName && (
                        <p className="mb-1 modalInfo">
                          {t("productName")}: {apiProductName}
                        </p>
                      )} */}

                      {/* <img src={apiProductName.toLowerCase().includes("delegate") ? GenuityCheckDelegate : GenuityCheckTracer} alt="GenuityCheck" style={{ width: '100px' }} /> */}
                      {/* <img src={Packet} alt="GenuityCheck" style={{ width: '200px', margin: '1.5rem 0rem 4rem 0rem' }} />
                      <img src={Not_Genuine} alt="Not_Genuine" className="notGenuine_corteva_product" /> */}

                      <img src={Wrongotp} alt='Wrongotp' className='img-fluid my-4 d-block mx-auto' />

                      {scanedDataObject.primaryRewardMsg && (
                        <p style={{ fontWeight: '600', color: '#000000', textAlign: 'center' }}>
                          {scanedDataObject?.primaryRewardMsg}
                        </p>
                      )}

                      {scanedDataObject.secondaryRewardMsg && (
                        <p style={{ fontWeight: '400', color: '#000000', textAlign: 'center' }} >
                          {scanedDataObject?.secondaryRewardMsg}
                        </p>
                      )}

{/* 
                      {scanedDataObject.isSpinDone && (
                        <p className="mb-0 modalInfo text-danger pt-2">
                          {scanedDataObject?.primaryRewardMsg}
                        </p>
                      )} */}


                      {/* <p className="mb-0 modalInfo">
                        {scanErrorResponseData?.uq_message}
                      </p> */}
                      {/* {scanErrorResponseData.isSpinDone && (
                        <p className="mb-0 modalInfo text-danger pt-2">
                          {scanErrorResponseData?.primaryRewardMsg}
                        </p>
                      )} */}
                    </>
                  }
                  footer={
                    <>
                      {/* <div className="d-flex justify-content-between w-100" style={{ gap: '.5rem' }}>
                        <Button
                          className="w-100 rounded-4 py-2 btn-secondary" onClick={() => {
                            navigate(`/${lang}/`)
                          }}>
                          {t("Done")}
                        </Button>

                        <Button
                          className="w-100 rounded-4 py-2  btn-secondary" onClick={() => {
                            ReactGA.event({
                              category: 'User Scan More',
                              action: 'Clicked the Scan More Button',
                            });
                            navigate(`/${lang}/scanProduct`)
                          }}>
                          {t("Scanmore")}
                        </Button>
                      </div> */}

                      <Button
                        className="w-100 rounded-4 py-2 btn-primary btnshadow" onClick={() => {
                          ReactGA.event({
                            category: 'User Scan More',
                            action: 'Clicked the Scan More Button',
                          });
                          setErrorModalGenunity(false)
                          navigate(`/${lang}/scanProduct`)
                        }}>
                        {/* {t("Scanmore")} */}
                        दोबारा स्कैन करें
                      </Button>

                    </>

                  }
                  show={ErrorModalGenunity}
                  onHide={() => setErrorModalGenunity(false)}
                />

                {/* //////////////////////////////////////////////////////////////////////////////////////////// */}
                {/* SPIN MODALS */}



                {/* spin modal */}
                <CustomModal
                  id={"spinModal"}
                  title={""}
                  content={
                    <>
                      <div>
                        {/* <img src={bannerLogoSrc} alt="Right" className="spinImgae spinwheelImg" /> */}

                        <div className="d-flex flex-direction-column align-items-center justify-content-center mb-3">
                          <p>पैकेट स्कैन किए :</p>
                          <p><img src={scanResponseData.centerWheelImgUrl} alt="Center" className="" /> {scanResponseData.scanCount} </p>
                        </div>

                        <CustomRoulette
                          wheelItems={scanResponseData.wheelItems}
                          stopPrizeNumber={stopPrizeNumber}
                          closeModal={handleCloseModal}
                          spinInnerImage={scanResponseData.centerWheelImgUrl}
                        />
                        {/* <img src={LeftArrow} alt="" style={{ position: 'absolute', zIndex: '10', bottom: "-20px", left: '-7px' }} />
                        <img src={RightArrow} alt="" style={{ position: 'absolute', zIndex: '10', bottom: "-20px", right: '-7px' }} /> */}

                      </div>
                    </>
                  }
                  footer={
                    <>
                      {secondaryRewardMsg && (

                        <p className="text-center my-2" style={{ fontSize: ' 0.9rem' }} dangerouslySetInnerHTML={{ __html: secondaryRewardMsg.replace(/\n/g, '<br />') }}></p>)}

                      <Button onClick={handleSpin} className="m-auto rounded-4 py-2 btnshadow btn-secondary" style={{ width: '93%' }}>
                        {t("Scanmore")}
                      </Button>

                      <Button onClick={handleSpin} className="m-auto rounded-4 py-2 btnshadow btn-secondary" style={{ width: '93%' }}>
                        {t('rewardJourney.proceed')}
                      </Button>

                    </>
                  }
                  show={spinModalShow}
                  onHide={() => setSpinModalShow(false)}
                />


                {/* ///reawrd update modal */}
                <CustomModal
                  id={"rewardUpdateModal"}
                  title={<>
                    <button
                      type="button"
                      className="close"
                      aria-label="Close"
                      onClick={handleNavigation}
                    >
                      <img src={Close} alt="Close" />
                    </button>

                  </>}
                  content={
                    <>
                      <img src={SuccessIcon} alt="SuccessIcon" className="succesIcon" />
                      <img src={giftImageUrl} alt="gifImage" className="giftedImg" />
                      <p className="congratulationsText mb-1 mt-1"> {t("giftcongratulations")} !!!</p>
                      <p className="rewardText mb-0" dangerouslySetInnerHTML={{ __html: genunityData.primaryRewardMsg }}></p>
                      {/* <img src={Fire} alt="fire" /> */}
                    </>
                  }
                  show={rewardUpdateModal}
                  onHide={() => {
                    setRewardUpdateModal(false); // Close the modal
                    handleNavigation();
                  }}
                />

              </div>
            </div>
          </div>
        </div>
        {errorMessage && (
          <div
            className="alert alert-warning alert-dismissible fade show mt-2"
            role="alert"
          >
            {errorMessage}
            <button
              type="button"
              className="close"
              onClick={hide}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default Login;
{/* <div>
                        <img src={Right} alt="Right" />
                      </div> */}
{/* <p className="mb-0 modalInfo fw-semibold">{scanResponseData?.uq_message}</p> */ }
{/* <p>{JSON.stringify(genunityData)}</p> */ }
{/* <p className="mb-0 modalInfo fw-semibold">{t('genuityProduct')}</p> */ }
{/* {scanResponseData.isSpinDone && (
                        <p className="mb-0 modalInfo text-danger pt-2">
                          {scanResponseData?.primaryRewardMsg}
                        </p>
                      )} */}